import { Column } from "../objects/column";
import {
    FunnelMandatoryPaxInfoParameterForm,
    FunnelMandatoryPaxInfoParameterListConfiguration,
    FunnelMandatoryPaxInfoParameterListCriteria,
    FunnelMandatoryPaxInfoParameterLocalization,
} from "../objects/funnelMandatoryPaxInfoParameter";

export const FUNNEL_MANDATORY_PAX_INFO_PARAMETER_MODULE = 'CIRCUIT_FUNNEL_MANDATORY_PAX_INFO_PARAMETER';

export const MANDATORY_PAX_INFO_PARAMETER_DEFAULT_COLUMNS: Column[] = [
    { label: 'name', field_name: 'NAME', checked: true, order_by: 'name', fixed_width: false, last_updated: false },
    { label: 'destination', field_name: 'DESTINATION', checked: true, order_by: '', fixed_width: false, last_updated: false },
    { label: 'modified-date', field_name: 'MODIFIED_DATE', checked: true, order_by: 'modified_date', fixed_width: true, last_updated: false },
    { label: 'modified-by', field_name: 'MODIFIED_BY', checked: false, order_by: 'last_author__username', fixed_width: true, last_updated: false },
    { label: 'created-date', field_name: 'CREATED_DATE', checked: false, order_by: 'created_date', fixed_width: true, last_updated: false },
    { label: 'created-by', field_name: 'CREATED_BY', checked: false, order_by: 'creator__username', fixed_width: true, last_updated: false },
];

export const EMPTY_FUNNEL_MANDATORY_PAX_INFO_PARAMETER_LIST_CONFIGURATION: FunnelMandatoryPaxInfoParameterListConfiguration = {
    columns: MANDATORY_PAX_INFO_PARAMETER_DEFAULT_COLUMNS,
    preferences: [],
};

export const EMPTY_FUNNEL_MANDATORY_PAX_INFO_PARAMETER_LOCALIZATION: FunnelMandatoryPaxInfoParameterLocalization = {
    name: '',
    locale: 0,
};

export const EMPTY_FUNNEL_MANDATORY_PAX_INFO_PARAMETER_FORM: FunnelMandatoryPaxInfoParameterForm = {
    name: null,
    name_localized: {},
    localization: [],
    destinations: [],
};

export const EMPTY_FUNNEL_MANDATORY_PAX_INFO_PARAMETER_LIST_CRITERIA: FunnelMandatoryPaxInfoParameterListCriteria = {
    limit: 25,
    page: 0,
    search: '',
    order: 'asc',
    order_by: '',
    cms_id: null,
    funnel_id: null,
};
